module.exports = __webpack_public_path__ + "img/picto-login.a05e1c90.svg";